module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01"
    }
  }, [_vm._v("1. Mental Healthcare in the Quaker City: The Origins of Byberry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Blockley Colony at Byberry Farms: Philly’s Funny Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Building Bedlam: The Crooked Construction Process")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Philadelphia Hospital for Mental Diseases: The City Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Philadelphia State Hospital: The State Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The New Approach: Deinstitutionalization at Byberry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The End of an Era: The Closure of PSH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Rediscovery of a Discarded Past: The Years of Abandon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/source",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0